/**
 * @file constants/routes.js
 * Costanti/factory per le rotte client-side dell'applicazione.
 * Le rotte parametriche (EXCEL, MERGE, SETUP…) sono funzioni che accettano l'id.
 */

export const ROUTES = {
  PLANNING:        '/planning',
  EXCEL:           (headerId) => `/planning/${headerId}/excel`,
  MERGE:           (headerId) => `/planning/${headerId}/merge`,
  MERGE_PUBLISHED: (headerId) => `/planning/${headerId}/merge-published`,
  DASHBOARD:       '/dashboard',
  CRITICITA:       '/criticita',
  SETUP:           (table)    => `/setup/${table}`,
  WORKBENCH:       '/workbench',
  PIANIFICAZIONE_DEFINITIVA: '/pianificazione-definitiva',
};
